import { graphql } from "react-relay";

export const EXTERNAL_LICENSE_POOLS_QUERY = graphql`
	query externalLicensePoolsScreen_Query($numItemsPerPage: Int!) {
		...externalLicensePoolsTable_ExternalLicensePoolsFragment
			@arguments(first: $numItemsPerPage, after: null)
	}
`;
